<template>
  <div class="inner-empty rtl padd-v-12">
      <span>{{ $t("tsiyunim.noMine") }}</span>
      <span>{{ $t("tsiyunim.toAddMine") }}</span>
      <span>{{ $t("tsiyunim.newMine") }}</span>
    <div class="add-tsiyun" @click.stop="addTsiyun">

      <span class="plus-tsiyun">+</span>

    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { IPUserNoPersDataMsg } from "@/services/userBooksData.js";
export default {
  props: ["title", "tabId"],
   computed:{
    ...mapGetters("user", ["isIPLimited"]),
  },
  methods: {
    ...mapActions("popupOnceComp", [
      "setVisible",
      "setInvisible",
      "toggleVisible",
      "setSlotShow",
      "setTabId"
    ]),
    addTsiyun(event) {

        if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      
      this.setTabId(this.tabId)
      this.setSlotShow("add-tsiyun");
      this.toggleVisible();
  
    }
  }
};
</script>
<style lang="scss" scoped>
.inner-empty {
 background-color: white;
 width:100%;
 height:100%;
 position: relative;
}
</style